import { render, staticRenderFns } from "./Acquisti.vue?vue&type=template&id=90e51134&scoped=true&"
import script from "./Acquisti.vue?vue&type=script&lang=js&"
export * from "./Acquisti.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90e51134",
  null
  
)

export default component.exports